export default {
  build: 'mq-3fc1434',
  builtAt: '1793853184',
};
